<template><svg xmlns="http://www.w3.org/2000/svg" width="14.085" height="14.04" viewBox="0 0 14.085 14.04">
  <g transform="translate(.085 .04)" fill="none">
    <rect width="14" height="14"/>
    <path d="M10.13 6.531 7.321 3.722l-6.28 6.28a.937.937 0 0 0 0 1.324l1.485 1.485a.936.936 0 0 0 1.324 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    <path d="M6.098 2.499a.469.469 0 0 1 .043-.7 4.214 4.214 0 0 1 5.913 5.913.469.469 0 0 1-.7.043ZM1.703 9.34h5.618M3.575 7.468h5.618" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
  </g>
</svg>
</template>